<app-join-membership-screen
  [isMobile]="false"
  [isDisabled]="isDisabled"
  [activatedAfterStripeRedirect]="activatedAfterStripeRedirect"
  [mainBtnTitle]="mainBtnTitle"
  (mainBtnClicked)="onMainBtnClick()"
  (backClicked)="onBackClick()"
  (freeTrialClicked)="onFreeTrialClick()">
</app-join-membership-screen>
